var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Header',[_c('UiTabs',[_c('UiTab',{attrs:{"to":"/leaderboards"}},[_vm._v("Prod")]),_c('UiTab',{attrs:{"to":"/leaderboards/heist"}},[_vm._v("Heist")]),_c('UiTab',{attrs:{"to":"/leaderboards/fights"}},[_vm._v("Fight")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }